// src/pages/superadmin/user/CreateUser.jsx
import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Grid,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SuperAdminLayout from "../../../layouts/SuperAdminLayout";
import api from "../../../utils/api";

const ROLE_OPTIONS = ["Manager", "Billing Staff"];

const CreateUser = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phoneNumber: "",
    role: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.id) {
      alert("Super admin not found");
      return;
    }

    try {
      await api.post("/api/users/create", {
        ...formData,
        superAdminId: user.id,
      });
      navigate("/super-admin/users");
    } catch (err) {
      console.error("Failed to create user:", err);
      alert("Error creating user");
    }
  };

  return (
    <SuperAdminLayout>
      <Paper sx={{ p: 4, maxWidth: "800px", mx: "auto" }}>
        <Typography variant="h5" gutterBottom>
          Create User
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Grid container spacing={2}>
            {/* Name */}
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </Grid>
            {/* Email */}
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Grid>
            {/* Password */}
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                label="Password"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
              />
            </Grid>
            {/* Phone Number */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Phone Number"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </Grid>
            {/* Role */}
            <Grid item xs={12} sm={6}>
              <TextField
                select
                required
                fullWidth
                label="Role"
                name="role"
                value={formData.role}
                onChange={handleChange}
              >
                {ROLE_OPTIONS.map((role) => (
                  <MenuItem key={role} value={role}>
                    {role}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            {/* Submit */}
            <Grid item xs={12} display="flex" justifyContent="flex-end">
              <Button variant="contained" color="primary" type="submit">
                Save User
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </SuperAdminLayout>
  );
};

export default CreateUser;
